import moment from 'moment';
export class ProductBatch {
  constructor() {
    (this.name = moment().format('DD-MM-YYYY')),
      (this.batchName = ''),
      (this.manufacureDate = ''),
      (this.expireryDate = ''),
      (this.productId = ''),
      (this.productBachUnitDetails = []);
    this.has_expiry_date = false;
  }
}
